var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-banner" },
    [
      _c(
        "div",
        {
          staticClass: "notification-message-container cpointer",
          on: { click: _vm.onClickBanner }
        },
        [
          _vm.isEmailNotification && !_vm.isSystemNotif
            ? [
                _c("NotificationEmail", {
                  attrs: { type: "banner", notification: _vm.data.notif }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isReminderActivity
            ? _c("NotificationReminderActivity", {
                attrs: {
                  notification: _vm.data.notif,
                  context: _vm.NOTIFICATION_CONTEXT.NOTIFICATION_BANNER
                }
              })
            : [
                _vm.showLogo
                  ? _c("CompassLogo", {
                      attrs: { type: "icon", theme: "light", width: 32 }
                    })
                  : _c("CompassAvatar", {
                      attrs: {
                        initials: _vm.getInitialsAvatar,
                        src: _vm.getSourceAvatar
                      }
                    }),
                _vm._v(" "),
                _vm.isSystemNotif
                  ? _c("p", [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(" " + _vm._s(_vm.data.linkedObject.name) + " : ")
                      ]),
                      _vm._v(" "),
                      _vm.isConsentNotification
                        ? _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.targetedStaffFullName) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.data.message))])
                    ])
                  : _c("p", [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$filters.capitalize(_vm.data.sender.firstname)
                            ) +
                            "\n                    " +
                            _vm._s(
                              _vm.$filters.capitalize(_vm.data.sender.lastname)
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.data.message) +
                            " " +
                            _vm._s(_vm.getTargetLabel(_vm.data))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.data.linkedObject.name))
                      ])
                    ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("CompassIconButton", {
        staticClass: "notification-close-button",
        attrs: { icon: "close", size: "small" },
        on: { click: _vm.onCloseNotif }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }